<template>
  <main class="mb-5 view-home full-height">
    <component
      :is="getVueComponent(component.type)"
      v-for="(component, index) in components"
      :key="index"
      :index="index"
      :configurations="component.configurations"
      :components="component.components"
    />
  </main>
</template>

<script>
import Vue from 'vue'
import LeafComponentSelector from '@/mixins/leaf-component-selector'

import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'Home',
  mixins: [
    LeafComponentSelector
  ],
  computed: {
    ...mapGetters({
      designConfig: 'tenantDesign/config'
    }),
    components () {
      return this.designConfig.pages['home'].components
    }
  }
})
</script>
